var common = require("../utiles/common.js");


module.exports = {
    queryDataByEquals:function(dto){
        return common.fetch(common.prefix+"/dataSearch/queryDataByEquals", {
            type: "POST",
            data: JSON.stringify(dto)
        }).data;
    },
    findOne:function(dto){
        dto.size = 1;
        var list = common.fetch(common.prefix+"/dataSearch/queryDataByEquals", {
            type: "POST",
            data: JSON.stringify(dto)
        }).data;
        if(list.result&&list.result.length>0){
            return list.result[0];
        }
        return undefined;
    },
    queryDataByFinder:function(dto){
        return common.fetch(common.prefix+"/dataSearch/queryDataByFinder", {
            type: "POST",
            data: JSON.stringify(dto)
        }).data;
    },
    queryDataByContains:function(dto){
        return common.fetch(common.prefix+"/dataSearch/queryDataByContains", {
            type: "POST",
            data: JSON.stringify(dto)
        }).data;
    },
    queryManageViewData:function(dto){
        return common.fetch(common.prefix+"/dataSearch/queryManageViewData", {
            type: "POST",
            data: JSON.stringify(dto)
        }).data;
    },
    listInheritAttributes:function(dto){
        return common.fetch(common.prefix+"/dataSearch/listInheritAttributes", {
            type: "POST",
            data: JSON.stringify(dto)
        }).data;
    },
    listAllAttributes:function(qualifyName){
        return common.fetch(common.prefix+"/dataAttr/listAllAttributes", {
            type: "get",
            query: {qualifyName}
        }).data;
    },
    loadForm:function(dto){
        dto.data = dto.data?dto.data:{};
        return common.fetch(common.prefix+"/action/loadForm", {
            type: "POST",
            data: JSON.stringify(dto)
        }).data;
    },
    execute:function(dto){
        dto.data = dto.data?dto.data:{};
        return common.fetch(common.prefix+"/action/execute", {
            type: "POST",
            data: JSON.stringify(dto)
        }).data;
    },
}


//////////////////
// WEBPACK FOOTER
// ./src/services/metaService.js
// module id = 7
// module chunks = 0